export default __webpack_public_path__ + "static/media/v45_61.b76dfd52.jpeg";